import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/App.scss?v=1.1.9';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Usa el método render de la raíz
root.render(
  <>
    <App />
  </>
);
